// extracted by mini-css-extract-plugin
module.exports = {"grid":"search_grid__34Zze","blur":"search_blur__1lt4w"};